<template>
  <s-page class="max-w-2xl mx-auto" v-if="isDataLoaded">
    <transfer-list />
    <modal-delete-transfer />
  </s-page>
</template>

<script>
import SPage from '@/components/SPage'
import TransferList from '@/components/TransferList'
import ModalDeleteTransfer from '@/components/ModalDeleteTransfer'
import { mapState } from 'vuex'

export default {
  name: 'TransfersView',
  components: {
    TransferList,
    SPage,
    ModalDeleteTransfer
  },
  computed: {
    ...mapState('config', ['isDataLoaded'])
  }
}
</script>
